import { useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '../constants/index';

export const useInvalidateQueries = (...keys: QueryKey[] | string[]) => {
  const queryClient = useQueryClient();

  return {
    invalidateQuery: (...additionalKeys: QueryKey[] | string[]) => {
      for (const key of [...keys, ...additionalKeys]) {
        queryClient.invalidateQueries({ queryKey: [key], exact: false });
      }
    },
  };
};
